import React from "react";

const MetricCard = ({ title, periods, color = "blue", icon }) => {
  const colorClasses = {
    blue: {
      border: "border-blue-500",
      bg: "bg-blue-50",
      text: "text-blue-600",
      iconBg: "bg-blue-100",
    },
    green: {
      border: "border-green-500",
      bg: "bg-green-50",
      text: "text-green-600",
      iconBg: "bg-green-100",
    },
    purple: {
      border: "border-purple-500",
      bg: "bg-purple-50",
      text: "text-purple-600",
      iconBg: "bg-purple-100",
    },
    orange: {
      border: "border-orange-500",
      bg: "bg-orange-50",
      text: "text-orange-600",
      iconBg: "bg-orange-100",
    },
    indigo: {
      border: "border-indigo-500",
      bg: "bg-indigo-50",
      text: "text-indigo-600",
      iconBg: "bg-indigo-100",
    },
  };

  const colors = colorClasses[color] || colorClasses.blue;

  const formatNumber = (num) => {
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toLocaleString();
  };

  return (
    <div
      className={`bg-white rounded-lg shadow-md p-6 border-l-4 ${colors.border} hover:shadow-lg transition-shadow duration-200`}
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
        </div>
        {icon && (
          <div className={`p-2 rounded-lg ${colors.iconBg}`}>
            <span className={`text-xl ${colors.text}`}>{icon}</span>
          </div>
        )}
      </div>

      <div className="space-y-3">
        {periods.map((period, index) => (
          <div key={index} className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-500">
              {period.label}
            </span>
            <span className={`text-2xl font-bold ${colors.text}`}>
              {formatNumber(period.value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetricCard;


